import { useMutation, useQueryClient } from '@tanstack/react-query';
import { codeApi } from '../api/codeApi';
import type { CommonCodeGroupRequest } from '../types/code';

/**
 * POST /api/eraf/codes/groups — 코드 그룹 생성
 * 성공 시 ['common-code', 'list'] 쿼리 무효화
 */
export function useCreateCodeGroup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CommonCodeGroupRequest) => codeApi.createGroup(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['common-code', 'list'] });
    },
  });
}
